import React from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../constants/clientRoutes";
import i18n from "../../i18n/config";
import ShieldTickImg from "../../assets/images/icons/shield-tick.png";

import FlowScreen from "../../components/Layouts/FlowScreen";
import MessageBlock from "../../components/Common/MessageBlock";

const FaceCheckHelp = () => {
  const history = useHistory();
  return (
    <FlowScreen
      className="v3"
      flowTitle={i18n.t("PAGES.FACECHECK.HELP.TITLE")}
      showBackButton={true}
      customBackButtonFunc={() => history.push(ROUTES.AUTH.LOGIN)}
    >
      <section className="max-w-450">
        <MessageBlock
          className="mb-24"
          actions={[]}
        >
          <>
            <div className="text-center">
              <img src={ShieldTickImg} alt="shield with tick" />
              <h3 className="mt-8">{i18n.t("PAGES.FACECHECK.HELP.INFO_BLOCK.TITLE")}</h3>
            </div>

            <p className="marengo-grey">{i18n.t("PAGES.FACECHECK.HELP.INFO_BLOCK.DESCRIPTION")}</p>
          </>
        </MessageBlock>

        <p className="brightwell-blue bold">{i18n.t("PAGES.FACECHECK.HELP.TIPS.TITLE")}</p>
        <p className="marengo-grey">{i18n.t("PAGES.FACECHECK.HELP.TIPS.DESCRIPTION")}</p>
        <ul className="marengo-grey mb-24">
          <li className="mb-2">{i18n.t("PAGES.FACECHECK.HELP.TIPS.TIP_1")}</li>
          <li className="mb-2">{i18n.t("PAGES.FACECHECK.HELP.TIPS.TIP_2")}</li>
          <li>{i18n.t("PAGES.FACECHECK.HELP.TIPS.TIP_3")}</li>
        </ul>

        <p className="brightwell-blue bold">{i18n.t("PAGES.FACECHECK.HELP.SUPPORT.TITLE")}</p>
        <p className="marengo-grey mb-16">{i18n.t("PAGES.FACECHECK.HELP.SUPPORT.DESCRIPTION")}</p>
      </section>
    </FlowScreen>
  )
};

export default FaceCheckHelp;